import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import TurnedInNotOutlinedIcon from "@mui/icons-material/TurnedInNotOutlined";
import TurnedInOutlinedIcon from "@mui/icons-material/TurnedInOutlined";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import SideBar from "../../sharedFiles/sideBar/SideBar";
import CustomizedBadges from "../../sharedFiles/cartBadge/cartBadge";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Tooltip } from "@mui/material";
import IOSSwitchComponent from '../../sharedFiles/ToggleButton/ToggleButton';

const BackIcon = ({ 
      cart
    , setModalShow
    , setGroupCode
    , cartUpdated
    , handlecartUpdate
    , isTableViews
    , handleToggleView
}) => {
    const location = useLocation();
    const { additionalData } = location.state || {};
    const navigate = useNavigate();
    const storedCart = JSON.parse(localStorage.getItem("cart") || '{}');
    // const [isTableView, setIsTableView] = useState(false);
    // const toggleItems = () => {
    //     if (isMobile) {
    //         setShowItems(false);
    //     }
    // };

    //********** This will helps to calculate a overall quantity of items in cart ********/
    const getTotalQuantity = () => {
        return Object.values(storedCart).reduce((total, item) => {
            const currentQuantity = item.quantity || 0;
            return total + currentQuantity;
        }, 0);
    };

    //********* This is for shows the sales order or sales quatation choosing modal ********/
    const handleIconClick = () => {
        setModalShow(true);
    };

    const handleBackNav = () => {
        navigate("/DashBoard");
        sessionStorage.removeItem('CustomerDetails');
    };

    const handlebackHistory=()=>{
        navigate("/orderHistory");
        localStorage.removeItem('cartTable')
        sessionStorage.removeItem('cart')
        localStorage.removeItem('docEntry')
        sessionStorage.removeItem('CustomerDetails')
    }
    return (
        <div className="backIconDiv">
            <div className=" d-flex  align-items-center ">
                <button onClick={additionalData?handlebackHistory:handleBackNav} className="border-0 d-flex align-items-center" style={{ backgroundColor: 'transparent' }}>
                    <ArrowBackIcon className="arrow-icon" />
                    {/* <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11">
                  Dashboard
                </p> */}
                </button>
            </div>
            <div className=" d-flex align-items-center gap-3">
                
                {isTableViews &&
                <div className='twoicons d-flex gap-1'>
                    {storedCart && cartUpdated ? (
                        <Tooltip title="Save for Later">
                            <IconButton onClick={handlecartUpdate}>
                                <TurnedInNotOutlinedIcon className="saveIcon" />
                            </IconButton>
                        </Tooltip>
                    ) : (
                        <Tooltip title="Cart Saved">
                            <IconButton >
                                <TurnedInOutlinedIcon className="saveIcon" />
                            </IconButton>
                        </Tooltip>
                    )}
                    {/* <CustomizedBadges
                        badgeContent={getTotalQuantity()}
                        onClick={handleIconClick}
                    /> */}
                    <SideBar setGroupCode={setGroupCode} />
                </div>}
                <div className="toggle-switch-container">
                    <IOSSwitchComponent checked={isTableViews} onChange={handleToggleView} />
                    <span>&nbsp;{isTableViews ? 'Table View' : 'Item Card'}</span>
                </div>
            </div>
        </div>
    )
}

export default BackIcon
